import React, { useContext, useEffect, useRef, useState } from "react";

import { useParams, useHistory } from "react-router-dom";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  makeStyles,
  useTheme,
  Paper,
  Tab,
  Tabs,
  TextField,
  Typography,
  Box,
  Card,
  CardContent,
  CardActions,
  Chip,
  Avatar,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
} from "@material-ui/core";
import {
  Add as AddIcon,
  Forum as ForumIcon,
  People as PeopleIcon,
  Message as MessageIcon,
  Info as InfoIcon,
  CheckCircle as CheckCircleIcon,
  Help as HelpIcon,
} from "@material-ui/icons";
import ChatList from "./ChatList";
import ChatMessages from "./ChatMessages";
import { UsersFilter } from "../../components/UsersFilter";
import api from "../../services/api";
import { SocketContext } from "../../context/Socket/SocketContext";

import { has, isObject } from "lodash";

import { AuthContext } from "../../context/Auth/AuthContext";
import withWidth, { isWidthUp } from "@material-ui/core/withWidth";

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    display: "flex",
    flexDirection: "column",
    position: "relative",
    flex: 1,
    padding: theme.spacing(2),
    height: `calc(100% - 48px)`,
    overflowY: "hidden",
    border: "1px solid rgba(0, 0, 0, 0.12)",
  },
  gridContainer: {
    flex: 1,
    height: "100%",
    border: "1px solid rgba(0, 0, 0, 0.12)",
    backgroundColor: theme.palette.dark,
  },
  gridItem: {
    height: "100%",
  },
  gridItemTab: {
    height: "92%",
    width: "100%",
  },
  btnContainer: {
    textAlign: "right",
    padding: 10,
  },
  // ✅ NUEVOS ESTILOS PARA MEJOR UX
  welcomeCard: {
    marginBottom: theme.spacing(3),
    background: `linear-gradient(135deg, ${theme.palette.primary.main}15, ${theme.palette.secondary.main}15)`,
    border: `1px solid ${theme.palette.primary.main}30`,
  },
  welcomeHeader: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
  welcomeIcon: {
    marginRight: theme.spacing(1),
    color: theme.palette.primary.main,
  },
  featureCard: {
    marginBottom: theme.spacing(2),
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: theme.shadows[4],
    },
  },
  featureIcon: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
  },
  selectedUsers: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  // ✅ CORREGIDO: HelpSection dinámico según tema
  helpSection: {
    backgroundColor: theme.mode === 'dark' ? '#374151' : theme.palette.grey[50],
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    marginTop: theme.spacing(2),
    border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
  },
  // ✅ CORREGIDO: DialogTitle dinámico según tema (mantiene color primario)
  dialogTitle: {
    display: "flex",
    alignItems: "center",
    backgroundColor: theme.palette.primary.main,
    color: "white",
    padding: theme.spacing(2),
    margin: theme.spacing(-2, -2, 2, -2),
    boxShadow: theme.mode === 'dark' ? '0 2px 8px rgba(0,0,0,0.3)' : '0 2px 8px rgba(0,0,0,0.1)',
  },
  // ✅ CORREGIDO: DialogContent dinámico según tema
  dialogContent: {
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
  },
  // ✅ CORREGIDO: SectionTitle dinámico según tema
  sectionTitle: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(2),
    color: theme.palette.primary.main,
  },
  // ✅ CORREGIDO: StepCard dinámico según tema
  stepCard: {
    marginBottom: theme.spacing(2),
    borderLeft: `4px solid ${theme.palette.primary.main}`,
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
    boxShadow: theme.mode === 'dark' ? '0 2px 8px rgba(0,0,0,0.3)' : '0 2px 8px rgba(0,0,0,0.08)',
  },
  // ✅ CORREGIDO: TextField dinámico según tema
  textField: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: theme.mode === 'dark' ? '#374151' : '#f5f5f5',
      color: theme.palette.text.primary,
      '&:hover': {
        backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#eeeeee',
      },
      '&.Mui-focused': {
        backgroundColor: theme.mode === 'dark' ? '#374151' : 'white',
        boxShadow: `0 0 0 2px ${theme.mode === 'dark' ? 'rgba(59, 130, 246, 0.3)' : 'rgba(25, 118, 210, 0.2)'}`,
      },
      "& fieldset": {
        borderColor: theme.mode === 'dark' ? '#4B5563' : '#e0e0e0',
      },
      "&:hover fieldset": {
        borderColor: theme.palette.primary.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
      },
    },
    "& .MuiInputLabel-root": {
      color: theme.palette.text.secondary || theme.palette.text.primary,
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: theme.palette.primary.main,
    },
    "& .MuiFormHelperText-root": {
      color: theme.palette.text.secondary || theme.palette.text.primary,
    },
  },
  // ✅ CORREGIDO: UserChip dinámico según tema
  userChip: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
    border: `1px solid ${theme.palette.primary.main}`,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  // ✅ CORREGIDO: ListItem dinámico según tema
  listItem: {
    backgroundColor: theme.mode === 'dark' ? 'transparent' : 'transparent',
    '&:hover': {
      backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#f5f5f5',
    },
  },
  // ✅ CORREGIDO: ListItemText dinámico según tema
  listItemText: {
    '& .MuiTypography-root': {
      color: theme.palette.text.primary,
    },
    '& .MuiTypography-body2': {
      color: theme.palette.text.secondary || theme.palette.text.primary,
    },
  },
}));

export function ChatModal({
  open,
  chat,
  type,
  handleClose,
  handleLoadNewChat,
}) {
  const classes = useStyles();
  const theme = useTheme();
  const [users, setUsers] = useState([]);
  const [title, setTitle] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    setTitle("");
    setUsers([]);
    setIsSaving(false);
    if (type === "edit") {
      const userList = chat.users.map((u) => ({
        id: u.user.id,
        name: u.user.name,
      }));
      setUsers(userList);
      setTitle(chat.title);
    }
  }, [chat, open, type]);

  const handleSave = async () => {
    // ✅ PREVENIR DOBLE CLIC
    if (isSaving) {
      console.log("⚠️ Guardado en progreso, ignorando clic duplicado");
      return;
    }

    try {
      if (!title.trim()) {
        alert("Por favor, ingresa un título para la conversación.");
        return;
      }

      if (!users || users.length === 0) {
        alert("Por favor, selecciona al menos un usuario para la conversación.");
        return;
      }

      setIsSaving(true);
      console.log("💾 Guardando conversación...", { title, users: users.length });

      if (type === "edit") {
        await api.put(`/chats/${chat.id}`, {
          users,
          title,
        });
        console.log("✅ Conversación actualizada correctamente");
      } else {
        const { data } = await api.post("/chats", {
          users,
          title,
        });
        console.log("✅ Conversación creada correctamente:", data.id);
        handleLoadNewChat(data);
      }
      handleClose();
    } catch (err) {
      console.error("❌ Error al guardar conversación:", err);
      alert("Error al guardar la conversación. Por favor, inténtalo de nuevo.");
    } finally {
      setIsSaving(false);
    }
  };

  const removeUser = (userId) => {
    setUsers(users.filter(user => user.id !== userId));
  };

  return (
      <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="chat-dialog-title"
      aria-describedby="chat-dialog-description"
      maxWidth="md"
      fullWidth
      PaperProps={{
        style: {
          backgroundColor: theme.palette.background.paper,
          border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
        },
      }}
    >
      <div className={classes.dialogTitle}>
        <ForumIcon style={{ marginRight: 8 }} />
        <Typography variant="h6">
          {type === "edit" ? "Editar Conversación" : "Nueva Conversación"}
        </Typography>
      </div>
      
      <DialogContent className={classes.dialogContent}>
        <Grid container spacing={3}>
          {/* ✅ SECCIÓN 1: INFORMACIÓN BÁSICA */}
          <Grid item xs={12}>
            <div className={classes.sectionTitle}>
              <InfoIcon style={{ marginRight: 8 }} />
              <Typography variant="h6">Información Básica</Typography>
            </div>
            
            <Card className={classes.stepCard}>
              <CardContent style={{ backgroundColor: theme.palette.background.paper }}>
                <TextField
                  label="Título de la conversación"
                  placeholder="Ej: Reunión de equipo, Proyecto XYZ, etc."
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  variant="outlined"
                  fullWidth
                  helperText="Ingresa un título descriptivo para identificar fácilmente esta conversación"
                  className={classes.textField}
                />
              </CardContent>
            </Card>
          </Grid>

          {/* ✅ SECCIÓN 2: SELECCIÓN DE USUARIOS */}
          <Grid item xs={12}>
            <div className={classes.sectionTitle}>
              <PeopleIcon style={{ marginRight: 8 }} />
              <Typography variant="h6">Participantes</Typography>
            </div>
            
            <Card className={classes.stepCard}>
              <CardContent style={{ backgroundColor: theme.palette.background.paper }}>
                <Typography variant="body2" style={{ color: theme.palette.text.secondary || theme.palette.text.primary }} gutterBottom>
                  Selecciona los usuarios que participarán en esta conversación:
                </Typography>
                
                <UsersFilter
                  onFiltered={(users) => setUsers(users)}
                  initialUsers={users}
                />
                
                {/* ✅ MOSTRAR USUARIOS SELECCIONADOS */}
                {users.length > 0 && (
                  <Box mt={2}>
                    <Typography variant="subtitle2" style={{ color: theme.palette.text.primary }} gutterBottom>
                      Usuarios seleccionados ({users.length}):
                    </Typography>
                    <div className={classes.selectedUsers}>
                      {users.map((user) => (
                        <Chip
                          key={user.id}
                          label={user.name}
                          onDelete={() => removeUser(user.id)}
                          className={classes.userChip}
                          avatar={<Avatar>{user.name.charAt(0).toUpperCase()}</Avatar>}
                        />
                      ))}
                    </div>
                  </Box>
                )}
              </CardContent>
            </Card>
          </Grid>

          {/* ✅ SECCIÓN 3: AYUDA CONTEXTUAL */}
          <Grid item xs={12}>
            <div className={classes.helpSection}>
              <div className={classes.sectionTitle}>
                <HelpIcon style={{ marginRight: 8 }} />
                <Typography variant="h6">¿Cómo funciona?</Typography>
              </div>
              
              <List dense>
                <ListItem className={classes.listItem}>
                  <ListItemAvatar>
                    <Avatar className={classes.featureIcon}>
                      <CheckCircleIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText 
                    className={classes.listItemText}
                    primary="Comunicación interna"
                    secondary="Este chat es privado y solo visible para los usuarios seleccionados"
                  />
                </ListItem>
                
                <ListItem className={classes.listItem}>
                  <ListItemAvatar>
                    <Avatar className={classes.featureIcon}>
                      <MessageIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText 
                    className={classes.listItemText}
                    primary="Mensajes en tiempo real"
                    secondary="Los mensajes se sincronizan automáticamente entre todos los participantes"
                  />
                </ListItem>
                
                <ListItem className={classes.listItem}>
                  <ListItemAvatar>
                    <Avatar className={classes.featureIcon}>
                      <PeopleIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText 
                    className={classes.listItemText}
                    primary="Colaboración eficiente"
                    secondary="Ideal para coordinación de equipos, proyectos y comunicación interna"
                  />
                </ListItem>
              </List>
            </div>
          </Grid>
        </Grid>
      </DialogContent>
      
      <DialogActions style={{ 
        padding: 16,
        backgroundColor: theme.palette.background.paper,
        borderTop: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
      }}>
        <Button 
          onClick={handleClose} 
          color="secondary"
          style={{ color: theme.palette.error.main }}
        >
          Cancelar
        </Button>
        <Button 
          onClick={handleSave} 
          color="primary" 
          variant="contained"
          startIcon={<AddIcon />}
          disabled={!title.trim() || users.length === 0 || isSaving}
        >
          {isSaving ? "Guardando..." : (type === "edit" ? "Actualizar" : "Crear Conversación")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function Chat(props) {
  const classes = useStyles();
  const { user } = useContext(AuthContext);
  const history = useHistory();

  const [showDialog, setShowDialog] = useState(false);
  const [dialogType, setDialogType] = useState("new");
  const [currentChat, setCurrentChat] = useState({});
  const [chats, setChats] = useState([]);
  const [chatsPageInfo, setChatsPageInfo] = useState({ hasMore: false });
  const [messages, setMessages] = useState([]);
  const [messagesPageInfo, setMessagesPageInfo] = useState({ hasMore: false });
  const [messagesPage, setMessagesPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [tab, setTab] = useState(0);
  const isMounted = useRef(true);
  const scrollToBottomRef = useRef();
  const { id } = useParams();

  const socketManager = useContext(SocketContext);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (isMounted.current) {
      findChats().then((data) => {
        const { records } = data;
        if (records.length > 0) {
          setChats(records);
          setChatsPageInfo(data);

          if (id && records.length) {
            const chat = records.find((r) => r.uuid === id);
            selectChat(chat);
          }
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isObject(currentChat) && has(currentChat, "id")) {
      findMessages(currentChat.id).then(() => {
        if (typeof scrollToBottomRef.current === "function") {
          setTimeout(() => {
            scrollToBottomRef.current();
          }, 300);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentChat]);

  useEffect(() => {
    const companyId = localStorage.getItem("companyId");
    const socket = socketManager.getSocket(companyId);
    
    console.log("💬 Chat: useEffect ejecutado - socket:", socket?.socket?.connected);

    socket.on(`company-${companyId}-chat-user-${user.id}`, (data) => {
      if (data.action === "create") {
        // ✅ PREVENIR DUPLICADOS: Solo agregar si no existe ya
        setChats((prev) => {
          const exists = prev.some(chat => chat.id === data.record.id);
          if (exists) {
            console.log("⚠️ Conversación ya existe en la lista, evitando duplicado:", data.record.id);
            return prev;
          }
          console.log("✅ Agregando nueva conversación a la lista:", data.record.id);
          return [data.record, ...prev];
        });
      }
      if (data.action === "update") {
        const changedChats = chats.map((chat) => {
          if (chat.id === data.record.id) {
            setCurrentChat(data.record);
            return {
              ...data.record,
            };
          }
          return chat;
        });
        setChats(changedChats);
      }
    });

    socket.on(`company-${companyId}-chat`, (data) => {
      if (data.action === "create") {
        // ✅ MANEJAR CREACIÓN DE CONVERSACIÓN DESDE EVENTO GENERAL
        setChats((prev) => {
          const exists = prev.some(chat => chat.id === data.record.id);
          if (exists) {
            console.log("⚠️ Conversación ya existe en la lista (evento general), evitando duplicado:", data.record.id);
            return prev;
          }
          console.log("✅ Agregando nueva conversación desde evento general:", data.record.id);
          return [data.record, ...prev];
        });
      }
      if (data.action === "delete") {
        const filteredChats = chats.filter((c) => c.id !== +data.id);
        setChats(filteredChats);
        setMessages([]);
        setMessagesPage(1);
        setMessagesPageInfo({ hasMore: false });
        setCurrentChat({});
        
        // ✅ REDIRIGIR SOLO SI LA CONVERSACIÓN ELIMINADA ERA LA ACTUAL
        if (currentChat.id === +data.id) {
          // ✅ CAMBIAR A PESTAÑA DE LISTA SI HAY OTRAS CONVERSACIONES
          if (filteredChats.length > 0) {
            setTab(0); // Cambiar a pestaña de lista
            history.push("/chats");
          } else {
            // ✅ NO HAY MÁS CONVERSACIONES, QUEDARSE EN PÁGINA PRINCIPAL
            setTab(0);
            history.push("/chats");
          }
        }
      }
    });

    if (isObject(currentChat) && has(currentChat, "id")) {
      socket.on(`company-${companyId}-chat-${currentChat.id}`, (data) => {
        if (data.action === "new-message") {
          setMessages((prev) => [...prev, data.newMessage]);
          const changedChats = chats.map((chat) => {
            if (chat.id === data.newMessage.chatId) {
              return {
                ...data.chat,
              };
            }
            return chat;
          });
          setChats(changedChats);
          scrollToBottomRef.current();
        }

        if (data.action === "update") {
          const changedChats = chats.map((chat) => {
            if (chat.id === data.chat.id) {
              return {
                ...data.chat,
              };
            }
            return chat;
          });
          setChats(changedChats);
          scrollToBottomRef.current();
        }
      });
    }

    // ✅ AGREGADO: Listener para mensajes de WhatsApp en tiempo real
    socket.on(`company-${companyId}-appMessage`, (data) => {
      console.log("🔔 Chat: Recibido appMessage:", data.action);
      
      if (data.action === "create") {
        const message = data.message;
        const chat = data.chat;
        
        // ✅ VALIDACIÓN CRÍTICA: Verificar que chat existe antes de acceder a sus propiedades
        if (!chat || !chat.id) {
          console.log("⚠️ Chat: Datos de chat inválidos, ignorando mensaje");
          return;
        }
        
        // ✅ Solo procesar si es el chat actual
        if (isObject(currentChat) && has(currentChat, "id") && currentChat.id === chat.id) {
          console.log("✅ Chat: Agregando mensaje al chat actual:", message.id);
          setMessages((prev) => [...prev, message]);
          
          // ✅ Actualizar el chat en la lista
          setChats((prevChats) => {
            return prevChats.map((c) => {
              if (c.id === chat.id) {
                return {
                  ...c,
                  lastMessage: message.body,
                  lastMessageAt: message.createdAt,
                  unreadMessages: c.unreadMessages + 1
                };
              }
              return c;
            });
          });
          
          // ✅ Scroll al final
          if (typeof scrollToBottomRef.current === "function") {
            setTimeout(() => {
              scrollToBottomRef.current();
            }, 100);
          }
        } else {
          console.log("ℹ️ Chat: Mensaje recibido para otro chat:", chat.id);
        }
      }
    });

    return () => {
      // ✅ SOLO REMOVER LISTENERS, NO DESCONECTAR EL SOCKET COMPARTIDO
      if (socket && typeof socket.off === 'function') {
        socket.off(`company-${companyId}-appMessage`);
        socket.off(`company-${companyId}-contact`);
        socket.off("ready");
        socket.off("connect");
        socket.off("disconnect");
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentChat, socketManager]);

  const selectChat = (chat) => {
    try {
      setMessages([]);
      setMessagesPage(1);
      setCurrentChat(chat);
      setTab(1);
    } catch (err) {}
  };

  const sendMessage = async (contentMessage) => {
    setLoading(true);
    try {
      await api.post(`/chats/${currentChat.id}/messages`, {
        message: contentMessage,
      });
    } catch (err) {}
    setLoading(false);
  };

  const deleteChat = async (chat) => {
    try {
      await api.delete(`/chats/${chat.id}`);
      
      // ✅ ACTUALIZAR LISTA DE CHATS DESPUÉS DE ELIMINAR
      const updatedChats = chats.filter(c => c.id !== chat.id);
      setChats(updatedChats);
      
      // ✅ SI LA CONVERSACIÓN ELIMINADA ERA LA ACTUAL, REDIRIGIR
      if (currentChat.id === chat.id) {
        setCurrentChat({});
        setMessages([]);
        setMessagesPage(1);
        setMessagesPageInfo({ hasMore: false });
        
        // ✅ REDIRIGIR A LISTA DE CONVERSACIONES SI HAY OTRAS, SINO A PÁGINA PRINCIPAL
        if (updatedChats.length > 0) {
          // Hay otras conversaciones, quedarse en la lista
          setTab(0); // Cambiar a pestaña de lista
          history.push("/chats");
        } else {
          // No hay más conversaciones, ir a página principal
          setTab(0);
          history.push("/chats");
        }
      }
      
      console.log("✅ Conversación eliminada correctamente:", chat.title);
    } catch (err) {
      console.error("❌ Error al eliminar conversación:", err);
    }
  };

  const findMessages = async (chatId) => {
    setLoading(true);
    try {
      const { data } = await api.get(
        `/chats/${chatId}/messages?pageNumber=${messagesPage}`
      );
      setMessagesPage((prev) => prev + 1);
      setMessagesPageInfo(data);
      setMessages((prev) => [...data.records, ...prev]);
    } catch (err) {}
    setLoading(false);
  };

  const loadMoreMessages = async () => {
    if (!loading) {
      findMessages(currentChat.id);
    }
  };

  const findChats = async () => {
    try {
      const { data } = await api.get("/chats");
      return data;
    } catch (err) {
      console.log(err);
    }
  };

  // ✅ COMPONENTE DE BIENVENIDA PARA MEJOR UX
  const renderWelcomeScreen = () => {
    return (
      <Box p={3}>
        {/* ✅ TARJETA DE BIENVENIDA */}
        <Card className={classes.welcomeCard}>
          <CardContent>
            <div className={classes.welcomeHeader}>
              <ForumIcon className={classes.welcomeIcon} />
              <Typography variant="h4" component="h1">
                Chat Interno
              </Typography>
            </div>
            
            <Typography variant="h6" color="textSecondary" paragraph>
              Sistema de comunicación interna para equipos y colaboración
            </Typography>
            
            <Typography variant="body1" paragraph>
              El Chat Interno te permite comunicarte de forma privada con otros miembros de tu equipo, 
              compartir información importante y coordinar proyectos de manera eficiente.
            </Typography>
          </CardContent>
        </Card>

        {/* ✅ CARACTERÍSTICAS PRINCIPALES */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <Card className={classes.featureCard}>
              <CardContent>
                <Avatar className={classes.featureIcon}>
                  <PeopleIcon />
                </Avatar>
                <Typography variant="h6" gutterBottom>
                  Comunicación Privada
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Chats privados solo visibles para los participantes seleccionados
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          
          <Grid item xs={12} md={4}>
            <Card className={classes.featureCard}>
              <CardContent>
                <Avatar className={classes.featureIcon}>
                  <MessageIcon />
                </Avatar>
                <Typography variant="h6" gutterBottom>
                  Tiempo Real
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Mensajes sincronizados instantáneamente entre todos los participantes
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          
          <Grid item xs={12} md={4}>
            <Card className={classes.featureCard}>
              <CardContent>
                <Avatar className={classes.featureIcon}>
                  <CheckCircleIcon />
                </Avatar>
                <Typography variant="h6" gutterBottom>
                  Colaboración Eficiente
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Ideal para coordinación de equipos, proyectos y comunicación interna
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* ✅ PASOS PARA COMENZAR */}
        <Card style={{ marginTop: 24 }}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              ¿Cómo comenzar?
            </Typography>
            
            <List>
              <ListItem>
                <ListItemAvatar>
                  <Avatar style={{ backgroundColor: '#4CAF50' }}>1</Avatar>
                </ListItemAvatar>
                <ListItemText 
                  primary="Haz clic en 'Nueva Conversación'"
                  secondary="Crea tu primera conversación interna"
                />
              </ListItem>
              
              <ListItem>
                <ListItemAvatar>
                  <Avatar style={{ backgroundColor: '#2196F3' }}>2</Avatar>
                </ListItemAvatar>
                <ListItemText 
                  primary="Selecciona los participantes"
                  secondary="Elige los usuarios que participarán en la conversación"
                />
              </ListItem>
              
              <ListItem>
                <ListItemAvatar>
                  <Avatar style={{ backgroundColor: '#FF9800' }}>3</Avatar>
                </ListItemAvatar>
                <ListItemText 
                  primary="¡Comienza a chatear!"
                  secondary="Envía mensajes y mantén a tu equipo comunicado"
                />
              </ListItem>
            </List>
          </CardContent>
          
          <CardActions style={{ justifyContent: 'center', padding: 16 }}>
            <Button
              onClick={() => {
                setDialogType("new");
                setShowDialog(true);
              }}
              color="primary"
              variant="contained"
              size="large"
              startIcon={<AddIcon />}
            >
              Crear Primera Conversación
            </Button>
          </CardActions>
        </Card>
      </Box>
    );
  };

  const renderGrid = () => {
    // ✅ MOSTRAR PANTALLA DE BIENVENIDA SI NO HAY CONVERSACIONES
    if (chats.length === 0 && !loading) {
      return renderWelcomeScreen();
    }

    return (
      <Grid className={classes.gridContainer} container>
        <Grid className={classes.gridItem} md={3} item>
          <div className={classes.btnContainer}>
            <Button
              onClick={() => {
                setDialogType("new");
                setShowDialog(true);
              }}
              color="primary"
              variant="contained"
              startIcon={<AddIcon />}
              size="large"
              style={{
                borderRadius: 8,
                textTransform: 'none',
                fontWeight: 600,
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-2px)',
                  boxShadow: '0 6px 16px rgba(0,0,0,0.2)',
                }
              }}
            >
              Nueva Conversación
            </Button>
          </div>
          
          <ChatList
            chats={chats}
            pageInfo={chatsPageInfo}
            loading={loading}
            handleSelectChat={(chat) => selectChat(chat)}
            handleDeleteChat={(chat) => deleteChat(chat)}
            handleEditChat={() => {
              setDialogType("edit");
              setShowDialog(true);
            }}
          />
        </Grid>
        <Grid className={classes.gridItem} md={9} item>
          {isObject(currentChat) && has(currentChat, "id") ? (
            <ChatMessages
              chat={currentChat}
              scrollToBottomRef={scrollToBottomRef}
              pageInfo={messagesPageInfo}
              messages={messages}
              loading={loading}
              handleSendMessage={sendMessage}
              handleLoadMore={loadMoreMessages}
            />
          ) : (
            <Box 
              display="flex" 
              flexDirection="column" 
              alignItems="center" 
              justifyContent="center" 
              height="100%"
              p={3}
            >
              <ForumIcon style={{ fontSize: 64, color: '#ccc', marginBottom: 16 }} />
              <Typography variant="h6" color="textSecondary" gutterBottom>
                Selecciona una conversación
              </Typography>
              <Typography variant="body2" color="textSecondary" align="center">
                Elige una conversación de la lista para comenzar a chatear, o crea una nueva conversación
              </Typography>
            </Box>
          )}
        </Grid>
      </Grid>
    );
  };

  const renderTab = () => {
    // ✅ MOSTRAR PANTALLA DE BIENVENIDA SI NO HAY CONVERSACIONES EN MÓVIL
    if (chats.length === 0 && !loading) {
      return renderWelcomeScreen();
    }

    return (
      <Grid className={classes.gridContainer} container>
        <Grid md={12} item>
          <Tabs
            value={tab}
            indicatorColor="primary"
            textColor="primary"
            onChange={(e, v) => setTab(v)}
            aria-label="chat tabs"
            variant="fullWidth"
          >
            <Tab 
              label="Conversaciones" 
              icon={<ForumIcon />}
            />
            <Tab 
              label="Mensajes" 
              icon={<MessageIcon />}
              disabled={!isObject(currentChat) || !has(currentChat, "id")}
            />
          </Tabs>
        </Grid>
        
        {tab === 0 && (
          <Grid className={classes.gridItemTab} md={12} item>
            <div className={classes.btnContainer}>
              <Button
                onClick={() => {
                  setDialogType("new");
                  setShowDialog(true);
                }}
                color="primary"
                variant="contained"
                startIcon={<AddIcon />}
                fullWidth
                size="large"
                style={{
                  borderRadius: 8,
                  textTransform: 'none',
                  fontWeight: 600,
                  boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-2px)',
                    boxShadow: '0 6px 16px rgba(0,0,0,0.2)',
                  }
                }}
              >
                Nueva Conversación
              </Button>
            </div>
            <ChatList
              chats={chats}
              pageInfo={chatsPageInfo}
              loading={loading}
              handleSelectChat={(chat) => selectChat(chat)}
              handleDeleteChat={(chat) => deleteChat(chat)}
            />
          </Grid>
        )}
        
        {tab === 1 && (
          <Grid className={classes.gridItemTab} md={12} item>
            {isObject(currentChat) && has(currentChat, "id") ? (
              <ChatMessages
                chat={currentChat}
                scrollToBottomRef={scrollToBottomRef}
                pageInfo={messagesPageInfo}
                messages={messages}
                loading={loading}
                handleSendMessage={sendMessage}
                handleLoadMore={loadMoreMessages}
              />
            ) : (
              <Box 
                display="flex" 
                flexDirection="column" 
                alignItems="center" 
                justifyContent="center" 
                height="100%"
                p={3}
              >
                <MessageIcon style={{ fontSize: 64, color: '#ccc', marginBottom: 16 }} />
                <Typography variant="h6" color="textSecondary" gutterBottom>
                  Selecciona una conversación
                </Typography>
                <Typography variant="body2" color="textSecondary" align="center">
                  Ve a la pestaña "Conversaciones" y elige una conversación para comenzar a chatear
                </Typography>
              </Box>
            )}
          </Grid>
        )}
      </Grid>
    );
  };

  return (
    <>
      <ChatModal
        type={dialogType}
        open={showDialog}
        chat={currentChat}
        handleLoadNewChat={(data) => {
          console.log("🔄 handleLoadNewChat ejecutado:", data.id);
          setMessages([]);
          setMessagesPage(1);
          setCurrentChat(data);
          setTab(1);
          history.push(`/chats/${data.uuid}`);
          
          // ✅ REFRESCAR LISTA DE CHATS DESPUÉS DE CREAR NUEVA CONVERSACIÓN
          findChats().then((chatData) => {
            const { records } = chatData;
            if (records.length > 0) {
              setChats(records);
              setChatsPageInfo(chatData);
              console.log("✅ Lista de chats actualizada después de crear nueva conversación");
            }
          }).catch(err => {
            console.error("❌ Error al refrescar lista de chats:", err);
          });
        }}
        handleClose={() => setShowDialog(false)}
      />
      <Paper className={classes.mainContainer}>
        {isWidthUp("md", props.width) ? renderGrid() : renderTab()}
      </Paper>
    </>
  );
}

export default withWidth()(Chat);
